import { render, staticRenderFns } from "./tobuy.vue?vue&type=template&id=4586c196&scoped=true&"
import script from "./tobuy.vue?vue&type=script&lang=js&"
export * from "./tobuy.vue?vue&type=script&lang=js&"
import style0 from "./tobuy.vue?vue&type=style&index=0&id=4586c196&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4586c196",
  null
  
)

export default component.exports